import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { default as React, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { GET_ALL_FETCHED_STUDIES } from "../../appConstants";
import axiosInstance from "../AxiosInstance/AxiosInstance";
// import HeaderComponent from "../Headers/HeaderComponent";
import { DROPDOWN_QRSTUDIES_DATA } from "../../DropdownConstants";
import "../Headers/Header.css";
import HomeHeader from "../HomeHeader";
import "../HomeHeader.css";
import FetchStudiesModal from "../Modal/FetchStudiesModal";
import SideBar from "../SideBar/SideBar";
import DataTable from "../Tables/HomePatientTable";
import LoaderComponent from "./LoaderComponent/LoaderComponent";

const FetchDataTable = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loader, setloader] = useState(true);
  const [numberOfentries, setNumberOfentries] = useState(25);
  const [totaldata, settotaldata] = useState();
  const [sortby, setsortby] = useState("");
  const [received, setReceived] = useState(false);
  const [searchkeyword, setSearchKeyword] = useState({});
  const [count, setCount] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [add, setAdd] = useState(false);
  const [update, toggleUpdate] = useState(false);
  const [asc, setAsc] = useState(true);
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [searchWord, setSearchWord] = useState("");

  const handleModalClose = () => {
    setAdd(false);
  };

  function handleSearch(e) {
    setCount(1);
    const filterobj = { asc: asc, sort_by: sortby, keyword: e.target.value };
    setSearchWord(e.target.value);
    setSearchKeyword(filterobj);
  }
  const handlechange = () => {
    const filterobj = { asc: asc, sort_by: sortby, keyword: searchWord };
    setSearchKeyword(filterobj);
  };

  const handlePageChange = (page) => {
    if (page >= 0 && page <= totalPages) {
      setCount(page + 1);
    }
  };
  const handleoption = (e) => {
    if (totaldata > e.target.value) {
      setNumberOfentries(e.target.value);
    }
  };

  const handleOrder = () => {
    if (sortby !== "") {
      const filterobj = { asc: !asc, sort_by: sortby, keyword: searchWord };
      setSearchKeyword(filterobj);
      setAsc((asc) => !asc);
    }
  };

  const handleclick = () => {
    setAdd(true);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        setloader(false);
        const response = await axiosInstance.post(
          `${GET_ALL_FETCHED_STUDIES}?page=${count}&size=${numberOfentries}`,
          searchkeyword,
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        );
        // console.log(response.data);
        setData(response.data.items);
        setTotalPages(response.data.pages);
        settotaldata(response.data.total);
        setloader(true);
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        setloader(true);
      }
    };

    fetchData();
  }, [searchkeyword, count, update, deleteAlert, numberOfentries]);

  useEffect(() => {
    setReceived(true);
    // updatedData;
  }, [data]);

  useEffect(() => {
    handlechange();
  }, [sortby]);
  useEffect(() => {
    const isAuthenticated = localStorage.getItem("authenticated");
    if (isAuthenticated !== "true") {
      navigate("/login");
    }
  });

  return (
    <div className="d-flex min-vh-100  background">
      <SideBar />

      <HomeHeader />
      <div className="d-flex flex-column">
        <div className="header">
          <h6 className="header-text" style={{ fontFamily: "Montserrat" }}>
            QR STUDIES
          </h6>
          <div className="d-flex justify-content-between mb-5">
            <div className="d-flex justify-content-start gap-3">
              <div>
                <h6
                  style={{
                    fontFamily: "Montserrat",
                    color: "#0fc4a0",
                    fontSize: "14px",
                  }}
                >
                  Sort by
                  <span style={{ color: "black" }}>&nbsp;||&nbsp;</span>
                  <span
                    style={{
                      color: "rgb(249, 215, 161)",
                      cursor: "pointer",
                    }}
                  >
                    <span onClick={handleOrder}>{asc ? "Desc" : "Asc"}</span>
                    {asc ? (
                      <i className="fa fa-sort-amount-asc"></i>
                    ) : (
                      <i className="fa fa-sort-amount-desc"></i>
                    )}
                  </span>
                </h6>
                <Select
                  displayEmpty
                  placeholder="Sort by"
                  className="sort"
                  name="Sort"
                  value={sortby || ""}
                  onChange={(e) => {
                    setsortby(e.target.value);
                  }}
                  style={{ color: "white", height: "39px" }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        backgroundColor: "#121c1b",
                        color: "white",
                        borderRadius: "5px",
                        border: "1px solid #0fc4a0",
                      },
                    },
                  }}
                >
                  <MenuItem value="" style={{ fontSize: "14px" }}>
                    Select
                  </MenuItem>

                  {data &&
                    data.length > 0 &&
                    DROPDOWN_QRSTUDIES_DATA.map((option) => (
                      <MenuItem
                        key={option.label}
                        value={option.value}
                        style={{ fontSize: "14px" }}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                </Select>
              </div>
              <div className="mr-4 d-flex flex-column justify-content-between">
                <h6
                  style={{
                    fontFamily: "Montserrat",
                    color: "#0fc4a0",
                    fontSize: "14px",
                  }}
                >
                  Search
                </h6>
                <input
                  style={{ height: "39px" }}
                  type="search"
                  placeholder="Search here"
                  className="search"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSearch(e);
                    }
                  }}
                />
              </div>
            </div>
            <button
              type="button"
              className="btn  mr-4 shadow  btn-dataset"
              style={{
                height: 39,
                width: 200,
                color: "black",
                backgroundColor: "#0FC4A0",
                position: "relative",
                top: 25,
                fontWeight: "bold",
                cursor: "pointer",
                fontFamily: "Montserrat",
              }}
              onClick={handleclick}
            >
              QR STUDIES
            </button>
          </div>
          <div></div>
        </div>

        {loader ? (
          <div>
            <DataTable
              handlePage={handlePageChange}
              viewTable={received}
              setViewTable={setReceived}
              count={count}
              totalPages={totalPages}
              data={data}
              type={"fetchStudyTable"}
              setAdd={setAdd}
              deleteAlert={deleteAlert}
              setDeleteAlert={setDeleteAlert}
              numberOfentries={numberOfentries}
              totaldata={totaldata}
              handleoption={handleoption}
            />
          </div>
        ) : (
          <div
            className="d-flex align-items-center justify-content-between"
            style={{ margin: "10vw 48vw" }}
          >
            <div>
              <LoaderComponent />
            </div>
          </div>
        )}

        {add && (
          <FetchStudiesModal
            ModalState={add}
            handleClose={handleModalClose}
            update={update}
            toggleUpdate={toggleUpdate}
          />
        )}
      </div>
    </div>
  );
};

export default FetchDataTable;
